var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestimonialBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 512,
    viewBox: "0 0 403 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 403,
    height: 512,
    fill: "#3B368F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.298,
    y: -45.0381,
    width: 77.6972,
    height: 639.889,
    transform: "rotate(18.5775 261.298 -45.0381)",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.877 470.353L266.016 473.761C301.091 485.55 339.082 466.673 350.871 431.598L476.856 56.7533L403.207 32.0001L255.877 470.353Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7085 63.5088C73.4971 28.4338 111.488 9.55661 146.563 21.3453L156.702 24.7533L-33.3509 590.221L-107 565.468L61.7085 63.5088Z",
    fill: "white",
    fillOpacity: 0.07
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 403,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialBackground);
export default __webpack_public_path__ + "static/media/testimonial-background.65958af3179b14348eebf76912f123cd.svg";
export { ForwardRef as ReactComponent };